import { render, staticRenderFns } from "./SuccessfulModal.vue?vue&type=template&id=65fbb4d6&scoped=true"
import script from "./SuccessfulModal.vue?vue&type=script&lang=js"
export * from "./SuccessfulModal.vue?vue&type=script&lang=js"
import style0 from "./SuccessfulModal.vue?vue&type=style&index=0&id=65fbb4d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fbb4d6",
  null
  
)

export default component.exports